import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
export const getPricingPlans = () => __awaiter(void 0, void 0, void 0, function* () {
    return AjaxUtils.get('/api/v1/pricing/plans');
});
